import { useParams, Link } from 'react-router-dom';
import { categories, newsArticles } from '@/mocks/news';

export default function CategoryHero() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const displayName = category?.name || '分类';

  return (
    <section className="relative w-full h-[420px] md:h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20abstract%20background%20with%20orange%20and%20amber%20gradients%2C%20dark%20edges%2C%20cinematic%20atmosphere%2C%20mysterious%20and%20provocative%20tone%2C%20entertainment%20news%20theme%2C%20rich%20warm%20colors%2C%20no%20text%2C%20smooth%20gradients%2C%20elegant%20dark%20vibe&width=1920&height=1080&seq=category-hero-bg&orientation=landscape"
          alt={`${displayName} - 51黑料吃瓜网`}
          title={`${displayName} - 51黑料吃瓜网 分类浏览`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/25 to-black/65"></div>

      <div className="relative z-10 w-full px-6 flex flex-col items-center text-center">
        <div className="flex items-center gap-2 text-foreground-400 text-xs mb-4">
          <Link to="/" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-600">{displayName}</span>
        </div>
        <h1 className="font-heading text-2xl md:text-5xl font-black text-foreground-950 tracking-wider uppercase">
          {displayName}
        </h1>
        <p className="mt-3 md:mt-4 text-foreground-400 text-sm md:text-base max-w-lg">
          {category?.description || '浏览最新内容'}
        </p>
      </div>
    </section>
  );
}